/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionnaireResponseScoreModel } from "./QuestionnaireResponseScoreModel";
import type { QuestionnaireResponseStatus } from "./QuestionnaireResponseStatus";

export interface QuestionnaireResponseSubmissionResponse {
  id: string;
  questionnaire_id: string;
  instrument_id: string;
  status: QuestionnaireResponseStatus;
  completed_at: string;
  scores: QuestionnaireResponseScoreModel[];
}
